import "intersection-observer/intersection-observer";
import "core-js/fn/promise";
import "core-js/es6/array";
import "formdata-polyfill";
import {URLSearchParams} from "@ungap/url-search-params";
import "element-closest/element-closest";
import "object-fit-polyfill/src/object-fit-polyfill";
import {SVGInject} from "./components/svg-inject/svg-inject.ts";
import {LazyLoadImages} from "./components/lazy-image/lazy-image.ts";
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

/**
 * Main Application
 */
export class Uwschilderwerk {

    constructor() {
        this.init()
            .then(() => {
                // tslint:disable-next-line:no-console
                console.log("App OK");
            })
            .catch((error) => {
                // tslint:disable-next-line:no-console
                console.error("App Error", error);
            });
    }

    private async init() {
        try {
            await LazyLoadImages.init();

            SVGInject.autoInit();

            // Native Javascript
            await Promise.all([
                import("./javascript/toggle-menu" as any),
                import("./javascript/scroll-to" as any),
                import("./javascript/swiper-slider" as any),
                // import("./javascript/nav-scroll-detect" as any),
                import("./javascript/fixed-contact" as any),
                import("./javascript/tabs" as any),
                import("./javascript/accordion-list" as any),
                import("./javascript/animation" as any),
                import("./javascript/detect-overflow" as any),
                import("./javascript/cookie" as any),
                import("./javascript/form-handler" as any),
                import("./javascript/ref-handler" as any),
            ]);

        } catch (error) {
            throw error;
        }
    }
}

const web = new Uwschilderwerk();



// WEBPACK FOOTER //
// ./web.ts